import React from 'react';
import type { PurchaseOrderDTO, PurchaseOrderItemDTO } from '@/services/purchaseOrder.service';
import type { CompanyPrintInfo } from '@/components/sales-invoice/PrintableSalesInvoice';
import type { ApprovalPrintSigner } from '@/services/approval.service';
import { EnginePurchaseOrderPrint } from '@/components/print/EngineLetterheadPrints';

export interface PrintablePurchaseOrderProps {
  po: PurchaseOrderDTO;
  items: PurchaseOrderItemDTO[];
  companyInfo?: CompanyPrintInfo;
  companyName?: string;
  approvalSigners?: ApprovalPrintSigner[];
  spotPurchaserName?: string | null;
  onClose?: () => void;
}

/** Purchase order print — shared pagination engine with restored letter layout. */
export const PrintablePurchaseOrder: React.FC<PrintablePurchaseOrderProps> = ({
  po,
  items,
  companyInfo: companyInfoProp,
  companyName: legacyCompanyName,
  approvalSigners,
  spotPurchaserName,
  onClose,
}) => {
  const companyInfo: CompanyPrintInfo = companyInfoProp ?? {
    name: legacyCompanyName ?? 'Company',
    address: '',
    phone: '',
    email: '',
    taxNumber: '',
  };
  return (
    <EnginePurchaseOrderPrint
      po={po}
      items={items}
      companyInfo={companyInfo}
      approvalSigners={approvalSigners}
      spotPurchaserName={spotPurchaserName}
      onClose={onClose}
    />
  );
};
